import React, {Fragment} from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Checkbox from 'material-ui/Checkbox'

const styles = {
    checkbox: {
        labelStyle: { fontSize: '14px', color: '#333' }
    },
};

class Facilities extends React.Component {
    render() {
        const { port, newPort } = this.props;

        return (
            <Fragment>
                <div className="main__title">
                    facilities
                </div>

                <div className="facilities">
                    <div className="row divided">
                        <div className={newPort.facilities.breakBulk !== port.facilities.breakBulk ? "col-xs-4 border-bottom dirty-element" : "col-xs-4 border-bottom"}>
                            <Checkbox
                                name={'facilities.breakBulk'}
                                label="Break bulk"
                                labelStyle={styles.checkbox.labelStyle}
                                checked={newPort.facilities.breakBulk}
                                disabled
                            />
                        </div>
                        <div className={newPort.facilities.dryDock !== port.facilities.dryDock ? "col-xs-4 dirty-element" : "col-xs-4"}>
                            <Checkbox
                                name={'facilities.dryDock'}
                                label="Dry Dock"
                                labelStyle={styles.checkbox.labelStyle}
                                checked={newPort.facilities.dryDock}
                                disabled
                            />
                        </div>
                        <div className={newPort.facilities.roro !== port.facilities.roro ? "col-xs-4 dirty-element" : "col-xs-4"}>
                            <Checkbox
                                name={'facilities.roro'}
                                label="Ro-Ro"
                                labelStyle={styles.checkbox.labelStyle}
                                checked={newPort.facilities.roro}
                                disabled
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className={newPort.facilities.container !== port.facilities.container ? "col-xs-4 dirty-element" : "col-xs-4"}>
                            <Checkbox
                                name={'facilities.container'}
                                label="Container"
                                labelStyle={styles.checkbox.labelStyle}
                                checked={newPort.facilities.container}
                                disabled
                            />
                        </div>
                        <div className={newPort.facilities.lpg !== port.facilities.lpg ? "col-xs-4 dirty-element" : "col-xs-4"}>
                            <Checkbox
                                name={'facilities.lpg'}
                                label="LPG"
                                labelStyle={styles.checkbox.labelStyle}
                                checked={newPort.facilities.lpg}
                                disabled
                            />
                        </div>
                        <div className={newPort.facilities.lng !== port.facilities.lng ? "col-xs-4 dirty-element" : "col-xs-4"}>
                            <Checkbox
                                name={'facilities.lng'}
                                label="LNG"
                                labelStyle={styles.checkbox.labelStyle}
                                checked={newPort.facilities.lng}
                                disabled
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className={newPort.facilities.liquid !== port.facilities.liquid ? "col-xs-4 dirty-element" : "col-xs-4"}>
                            <Checkbox
                                name={'facilities.liquid'}
                                label="Liquid"
                                labelStyle={styles.checkbox.labelStyle}
                                checked={newPort.facilities.liquid}
                                disabled
                            />
                        </div>
                        <div className={newPort.facilities.multipurpose !== port.facilities.multipurpose ? "col-xs-4 dirty-element" : "col-xs-4"}>
                            <Checkbox
                                name={'facilities.multipurpose'}
                                label="Multipurpose"
                                labelStyle={styles.checkbox.labelStyle}
                                checked={newPort.facilities.multipurpose}
                                disabled
                            />
                        </div>
                        <div className={newPort.facilities.passenger !== port.facilities.passenger ? "col-xs-4 dirty-element" : "col-xs-4"}>
                            <Checkbox
                                name={'facilities.passenger'}
                                label="Passenger"
                                labelStyle={styles.checkbox.labelStyle}
                                checked={newPort.facilities.passenger}
                                disabled
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className={newPort.facilities.dryBulk !== port.facilities.dryBulk ? "col-xs-4 dirty-element" : "col-xs-4"}>
                            <Checkbox
                                name={'facilities.dryBulk'}
                                label="Dry Bulk"
                                labelStyle={styles.checkbox.labelStyle}
                                checked={newPort.facilities.dryBulk}
                                disabled
                            />
                        </div>
                        <div className={newPort.facilities.bunkering !== port.facilities.bunkering ? "col-xs-4 dirty-element" : "col-xs-4"}>
                            <Checkbox
                                name={'facilities.bunkering'}
                                label="Bunkering"
                                labelStyle={styles.checkbox.labelStyle}
                                checked={newPort.facilities.bunkering}
                                disabled
                            />
                        </div>
                        <div className={newPort.facilities.steel !== port.facilities.steel ? "col-xs-4 dirty-element" : "col-xs-4"}>
                            <Checkbox
                                name={'facilities.steel'}
                                label="Steel"
                                labelStyle={styles.checkbox.labelStyle}
                                checked={newPort.facilities.steel}
                                disabled
                            />
                        </div>
                    </div>


                    <div className="row">
                        <div className={newPort.facilities.shipyard !== port.facilities.shipyard ? "col-xs-4 dirty-element" : "col-xs-4"}>
                            <Checkbox
                                name={'facilities.shipyard'}
                                label="Shipyard"
                                labelStyle={styles.checkbox.labelStyle}
                                checked={newPort.facilities.shipyard}
                                disabled
                            />
                        </div>

                        <div className={newPort.facilities.reefer !== port.facilities.reefer ? "col-xs-4 dirty-element" : "col-xs-4"}>
                            <Checkbox
                                name={'facilities.reefer'}
                                label="Reefer"
                                labelStyle={styles.checkbox.labelStyle}
                                checked={newPort.facilities.reefer}
                                disabled
                            />
                        </div>
                    </div>

                </div>
            </Fragment>
        );
    }
}

Facilities.propTypes = {

};

Facilities.defaultProps = {

};

export default connect(
    (state, { port, newPort }) => {
        return {
            port,
            newPort,
        };
    },
    dispatch => bindActionCreators({

    }, dispatch),
)(Facilities);


// WEBPACK FOOTER //
// ./app/components/Regions/PortApprove/Facilities.jsx